import React, { useState, useEffect } from "react";
import "./style.scss";
//nav bar
import Navbar from "../../../components/navbar/navbar";
import PageHeader from "../../../components/pageComponents/header";
import ThreeColText from "../../../components/pageComponents/threeColText";
// utile
import { debounce } from "../../../utils/debounce";
import { useTranslation } from "react-i18next";
import Footer from "../../../components/footer/footer";

const MythePage = () => {
  const { t } = useTranslation();
  const [isMobile, setMobile] = useState(
    window.innerWidth <= 600 || window.innerHeight <= 650
  );

  const debouncedHandleResize = debounce(function handleResize() {
    setMobile(window.innerWidth <= 600 || window.innerHeight <= 650);
  }, 300);

  useEffect(() => {
    window.addEventListener("resize", debouncedHandleResize);

    return (_) => {
      window.removeEventListener("resize", debouncedHandleResize);
    };
  });

  return (
    <div className="App">
      {!isMobile && <Navbar />}
      <div className={isMobile ? "page__mobile" : "page"}>
        <div className="App-header">
          <PageHeader
            title1={t("mythe_rite_title1")}
            title2={t("mythe_rite_title2")}
            subtitle={t("mythe_subtitle")}
            color="#ffcc00"
            bgImg={require("../../../images/pages/MytesRites.jpg")}
            isMobile={isMobile}
          >
            <div className="page__content">{t("mythe_text_intro_1")}</div>
            <div className="page__content">{t("mythe_text_intro_2")}</div>
          </PageHeader>
        </div>
        <ThreeColText
          col1Txt={[t("mythe_text_core_1")]}
          col2Txt={[t("mythe_text_core_2a"),t("mythe_text_core_2b"),t("mythe_text_core_2c")]}
          col3Txt={[t("mythe_text_core_3a"),t("mythe_text_core_3b")]}
          col1Title={[
            t("mythe_text_title_1a"),
            t("mythe_text_title_1b"),
            t("mythe_text_title_1c"),
          ]}
          col2Title={[
            t("mythe_text_title_2a"),
            t("mythe_text_title_2b"),
            t("mythe_text_title_2c"),
          ]}
          col3Title={[
            t("mythe_text_title_3a"),
            t("mythe_text_title_3b"),
            t("mythe_text_title_3c"),
          ]}
          color="#ffcc00"
        />
      </div>
    </div>
  );
};

export default MythePage;
